import controller from './actions.controller';

const template = require('./actions.html');

export default {
    bindings: {
        actions: '<'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/actions.component.js